module.exports = __webpack_public_path__ + "img/success@3x.ce2819ce.png";